module.exports = __webpack_public_path__ + "0947d454.svg";